import React from "react";
import cx from "classnames";
import snarkdown from "snarkdown";

export default function PremiumAlert({
  isLoggedIn,
  isPremium,
  isPremiumIn,
  goTo,
  text,
  className,
  city
}) {
  const content = text
    .split("|")
    .map((txt, idx) => (
      <p key={idx} dangerouslySetInnerHTML={{ __html: snarkdown(txt) }} />
    ));

  const css = cx(className, "alert alert--premium");

  if (!isLoggedIn) {
    return (
      <div className={css}>
        {content}
        <span>
          <a className="u-link" onClick={ev => goTo("login")}>
            Login
          </a>
          &nbsp;or&nbsp;
          <a className="u-link" href="/premium">
            Sign Up
          </a>
        </span>
      </div>
    );
  }

  if (isPremium && !isPremiumIn) {
    return (
      <div className={css}>
        {content}
        <p>
          Your premium membership is{" "}
          <strong>not available for {city.name}</strong>.
          <br />
          <a className="u-link" target="_blank" href="/purchase">
            Upgrade now
          </a>
        </p>
      </div>
    );
  }

  if (!isPremium) {
    return (
      <div className={css}>
        {content}
        <a className="u-link" target="_blank" href="/purchase">
          Renew Subscription
        </a>
      </div>
    );
  }

  return null;
}
